import React from "react";
import { Icon } from "../../designSystem";

const GLYPHS = {
  error: "error",
  success: "check_circle",
  info: "info",
  warning: "warning",
};

/** 行内提示条（替代 MUI Alert）。variant: error | success | info | warning */
export default function Notice({ variant = "info", children, style, className = "" }) {
  if (!children) return null;
  return (
    <div className={`lt-notice lt-notice--${variant} ${className}`} style={style} role="alert">
      <Icon name={GLYPHS[variant] || GLYPHS.info} fill />
      <span>{children}</span>
    </div>
  );
}
